import { exportExcelMain } from '../../utils/export-excel';
import { DownloadIcon } from 'src/components/ui-icons/upload';
import { Block, Department, UniversalObject } from '../../types/data';
import { TooltipItem } from "src/utils/Tooltip";

type ExportExcelMainProps = {
  data: Block[];
  departments: Department[];
  params: {
    factory: UniversalObject,
    gop: UniversalObject,
    direction: UniversalObject
  };
}

function ExportExcelMain({ data, departments, params }: ExportExcelMainProps) {
  return (
    <TooltipItem position="top" tooltipsText={'Экспорт в Excel'}>
      <button
        className="rounded-md bg-white p-4 shadow-md h-full"
        type="button"
        onClick={() => exportExcelMain(data, departments, params)}>
        <DownloadIcon />
      </button>
    </TooltipItem>
  )
}

export default ExportExcelMain;
